import API from "shared/services/Api";
import { IDashboardResponse } from "shared/types/Indicators";

interface IDash {
  userId: string;
  date: string;
  ano: string;
  mes: string;
}
export const getDashboardData = async (
  data: IDash
): Promise<IDashboardResponse> =>
  API.get(
    `oc/dashboard-dentista?id=${data.userId}&date=${data.date}&ano=${data.ano}&mes=${data.mes}`
  );
